module.exports = __webpack_public_path__ + "page-maintenance-bg.jpg?b1da73ea0c3cf7f2eab14e9543725c6d";